import { UMButton, UMIcon, UMR } from '../../urbanmap/_components';
import { PLAN } from '../proposition-c/tokens';
import { PlanLogo, Pill, fmt } from '../proposition-c/ui';
import type { PlanProject } from './types';
import { AvatarStack } from './ui';

export function ProjectHeader({
  project, lineage, onEditParams, onInvite, showInvite, onOpenProjects, onBackToUM,
}: {
  project: PlanProject;
  lineage: { source: string; version: string; extractedAt: string };
  onEditParams: () => void;
  onInvite: () => void;
  showInvite: boolean;
  onOpenProjects: () => void;
  onBackToUM: () => void;
}) {
  return (
    <header
      style={{
        height: PLAN.headerHeight, flexShrink: 0, display: 'flex', alignItems: 'center', gap: 16, padding: '0 16px',
        borderBottom: `1px solid ${UMR.border}`, background: UMR.white, fontFamily: UMR.font,
      }}
    >
      <PlanLogo size={32} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{project.name}</div>
        <div style={{ fontSize: 12, color: UMR.textSecondary }}>
          {project.perimeterLabel} · {fmt(project.buildingCount)} bâtiments · copie figée du {project.createdAt}
        </div>
      </div>

      <Pill tone="neutral" icon="database" title={`${lineage.source} — version ${lineage.version}`}>
        {lineage.source.split(' — ')[0]} {lineage.version}
      </Pill>
      <Pill tone="accent" icon="gavel" title="Hypothèses imposées par le cahier des charges">
        {project.params.weatherStation} · {project.params.ratioResidential} % / {project.params.ratioTertiary} %
      </Pill>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
        <AvatarStack members={project.members} />
        {showInvite && <UMButton variant="secondary" icon="person_add" onClick={onInvite}>Inviter</UMButton>}
        <UMButton variant="secondary" icon="tune" onClick={onEditParams}>Hypothèses de l’AO</UMButton>
        <button type="button" onClick={onOpenProjects} title="Mes projets" style={iconBtn}>
          <UMIcon name="folder_open" size={20} color={UMR.text} />
        </button>
        <button type="button" onClick={onBackToUM} title="Retour à UrbanMap" style={iconBtn}>
          <UMIcon name="arrow_back" size={20} color={UMR.text} />
        </button>
      </div>
    </header>
  );
}

const iconBtn = {
  width: 32, height: 32, border: `1px solid ${UMR.border}`, background: UMR.white,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
} as const;
